<template>
  <section
    class="main-layout theme-grey-full"
    :class="{ 'sidebar-opened': this.$store.state.sidebar.visible,
              'sidebar-mini': this.$store.state.sidebar.mini }"
  >
    <navbar />
    <sidebar />

    <section class="main-content-wrapper">
      <child />
    </section>
    <notifications />
  </section>
</template>

<script>
import Navbar from '~/components/Navbar';
import Sidebar from '~/components/Sidebar';
import Notifications from '~/components/Notifications';

export default {
  name: 'MainLayout',

  components: {
    Navbar,
    Sidebar,
    Notifications,
  },
  mounted() {
    // Add a response interceptor
    window.axios.interceptors.response.use((response) => {
      if (!!response.data.type && !!response.data.message) {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
      }
      return response;
    }, (error) => {
      let errores = '';
      if (error.response.data.errors) {
        // Request made and server responded
        const errors = Object.values(error.response.data.errors);
        errors.forEach((element) => {
          errores += element;
        });
      } else if (error.request) {
        // The request was made but no response was received
        errores = 'Ocurrió un error en la comunicación con el servidor.';
      } else {
        // Something happened in setting up the request that triggered an Error
        errores = 'Ocurrió un error en la comunicación con el servidor.';
      }
      this.$store.dispatch('notifications/show', {
        message: errores,
        type: 'error',
      });
      return Promise.reject(error);
    });
  },
};
</script>
<style lang="scss">
@import "../../public/sass/app.scss";
</style>
